import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import columns from 'utils/tables/columns/administration/descriptorTypes';

/**
 * The seven descriptor types, to look at.
 *
 * No Add, no edit, no delete, and the API has no route for any of them either.
 * These seven rows are the same in every installation and five of them are
 * named by primary key in utils/constants/descriptorTypes.js - PC is 70004, SU
 * is 70002, ERC is 70003, PROC is 70005 - which thirty files import to decide
 * which screen to draw. Renaming one here would not break anything visibly; it
 * would leave a screen empty and quiet.
 *
 * It used to offer all three. The verification runs left twelve blank rows in
 * the scratch database, one per persona that pressed Add.
 */
const Component = props => {
  const { descriptorTypes } = props;
  const tableRef = React.useRef(null);

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        columns={columns}
        data={descriptorTypes}
        onRowClick={() => null}
      />
    </Grid>
  );
};


const makeMapStateToProps = () => {
  const immutableDescriptorTypes = getImmutableStoreData('descriptorTypes');
  const mapStateToProps = (state, props) => ({
    descriptorTypes: immutableDescriptorTypes(state)
  });
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(Component);
